
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import { Component } from 'react';
import { connect } from 'react-redux';
import { SwarmDataMixin, getSwarmDataKeyForRequest } from "../../../../dev/mixins/swarmDataMixin";
import PropTypes from "prop-types";
import Config from "../../../config/main";
import { getSwarmSubscriptionRequestPromotedGames } from "../../../helpers/terminalRequests/promotedGames";
import { MatchOfTheDayGamesListUpdateReceived, ResetMatchOfTheDayGamesList } from "../../../actions/matchOfTheDayActions";
import { handleGameListMatchOfTheDaySubscriptionData } from "../../../helpers/matchOfTheDayHelpers";
import { createSelector } from "reselect";

class MatchOfTheDay extends Component {
    constructor (props) {
        super(props);
        this.resolution = Config.terminal.featuredGames || ((document.getElementById("root").offsetWidth / document.getElementById("root").offsetHeight) > 1.5 ? 4 : 6);
        this.nextPage = this.nextPage.bind(this);
        this.previousPage = this.previousPage.bind(this);
        this.getGamesPerPage = this.getGamesPerPage.bind(this);
        this.state = {
            page: 1,
            sliceParams: [0, this.resolution]
        };
    }

    nextPage (gamesLenght) {
        return () => this.state.page < (Math.ceil(gamesLenght / this.resolution)) ? this.setState({
            page: this.state.page + 1,
            sliceParams: [this.state.sliceParams[0] + this.resolution,
                this.state.sliceParams[1] + this.resolution]
        })
            : this.setState({page: 1, sliceParams: [0, this.resolution]});
    }

    previousPage (gamesLenght) {
        return () => this.state.page > 1 ? this.setState({
            page: this.state.page - 1,
            sliceParams: [this.state.sliceParams[0] - this.resolution,
                this.state.sliceParams[1] - this.resolution]
        }) : this.setState({
            page: Math.ceil(gamesLenght / this.resolution),
            sliceParams: [Math.ceil(this.resolution * Math.ceil(gamesLenght / this.resolution)) - this.resolution,
                this.resolution * Math.ceil(gamesLenght / this.resolution)]
        });
    }

    getGamesPerPage (data) {
        if(Config.enableScrollInHomePageUSA) {
        return data;
        }
        return data.slice(this.state.sliceParams[0], this.state.sliceParams[1]);
    }

    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }

    componentWillUnmount () {
        this.props.dispatch(ResetMatchOfTheDayGamesList());
    }
}

MatchOfTheDay.propTypes = {
    loaded: PropTypes.bool,
    promotedGames: PropTypes.array,
    count: PropTypes.number,
    selectorKey: PropTypes.string,
    showLiveGames: PropTypes.bool
};

const mapStateToProps = (_, ownParams) => {
    let key = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestPromotedGames(ownParams.count));
    return createSelector(
        [
            state => state.matchOfTheDayGamesList && state.matchOfTheDayGamesList[key] && JSON.stringify(Object.values(state.matchOfTheDayGamesList[key]).sort((a, b) => a.id - b.id)),
            state => state.swarmData.loaded[key]
        ],
        (promotedGames, loaded) => {
            return {
                promotedGames: promotedGames && JSON.parse(promotedGames),
                loaded,
                selectorKey: key
            };
        }
    );
};

export default connect(mapStateToProps)(SwarmDataMixin({
    Component: MatchOfTheDay,
    ComponentWillMount: function () {
        this.swarmSubscriptionRequest = getSwarmSubscriptionRequestPromotedGames(!this.props.showLiveGames && this.props.count);
        this.swarmDataKey = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestPromotedGames(!this.props.showLiveGames && this.props.count));
        this.meta = {
            simplify: true,
            preventOriginalAction: true,
            finalize: (loaded) => {
                return {
                    additionalActions: [MatchOfTheDayGamesListUpdateReceived.bind(null, handleGameListMatchOfTheDaySubscriptionData(loaded))]
                };
            }
        };
    }
}));